import type { Id, IncidentEntity, Nullable } from "@/models"
import { Instant, InstantSchema } from "@/Temporal"
import { arraySchema, nullableSchema, objectSchema } from "vue-utils"
import { SearchPattern } from "./SearchPattern"

export interface AssetTasked extends IncidentEntity {
	SRUId: Id

	/**
	 * Usually a list of numbers, with the maximum being the "totalCrew" field of the corresponding SRU
	 */
	crewLists: Nullable<number[]>

	customName: Nullable<string>
	notes: Nullable<string>
	taskingInstructions: Nullable<string>
	searchPattern: Nullable<SearchPattern>

	alerted: Nullable<Instant>
	departed: Nullable<Instant>
	onScene: Nullable<Instant>
	returning: Nullable<Instant>
	pierHeads: Nullable<Instant>
	backOnStation: Nullable<Instant>
}

export const AssetTasked = objectSchema<AssetTasked>({
	id: Number,
	SRUId: Number,

	crewLists: nullableSchema(arraySchema(Number)),

	customName: nullableSchema(String),
	notes: nullableSchema(String),
	taskingInstructions: nullableSchema(String),
	searchPattern: nullableSchema(SearchPattern),

	alerted: nullableSchema(InstantSchema),
	departed: nullableSchema(InstantSchema),
	onScene: nullableSchema(InstantSchema),
	returning: nullableSchema(InstantSchema),
	pierHeads: nullableSchema(InstantSchema),
	backOnStation: nullableSchema(InstantSchema),
})
